import React from 'react';
import {FormattedMessage} from "react-intl";

import './Testimonials.style.scss';

const Testimonials = () => {
    return (
        <section className="testimonials">
            <div className="title"><FormattedMessage id={'landingPage.testimonials.title'}/></div>
            <div className="testimonialsContent">
                {['1', '2', '3', '4'].map(n => (
                    <div className="testimonialsItem" key={`testimonial-${n}`}>
                        <div>
                            <div className="quoteIcon"/>
                            <p className="testimonialText"><FormattedMessage
                                id={`landingPage.testimonials.list.${n}.quote`}/></p>
                        </div>
                            <p
                                className="testimonialAuthor"><FormattedMessage
                                id={`landingPage.testimonials.list.${n}.author`}/></p>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default Testimonials;